// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.6";import * as Sentry from '@sentry/nextjs'

import { isTrackingOptedOut } from 'utils/privacyPreferences'
import { scrubEventPii } from 'utils/sentryPii'

const optedOutAtInit = isTrackingOptedOut()

Sentry.init({
  dsn:
    'https://efaebe68a831cc667d6bdb0e5dd2cdeb@o4510663507771392.ingest.us.sentry.io/4510794393255936',

  enabled: process.env.NODE_ENV === 'production',

  sendDefaultPii: !optedOutAtInit,

  beforeSend: (event) => (isTrackingOptedOut() ? scrubEventPii(event) : event),

  ignoreErrors: [/Failed to fetch/i, /Load failed/i, /Can't find variable: UET/i, /UET is not defined/i],
  denyUrls: [/tawk\.to/i]
})

// eslint-disable-next-line
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
